module.exports = __webpack_public_path__ + "static/16-5bacaf0d943e7104ee9ac43288d295d6.png";